<template>
  <v-card class="mx-auto" max-width="520px">
    <v-card-subtitle class="pt-5 mb-0 orange darken-2 white--text">
      <div class="mb-2">
        <v-img
          contain
          width="60"
          src="/favicon.png"
          class="shrink mx-auto"
          transition="scale-transition"
        />
      </div>
      <h2 class="text-center px-6">
        Get Voting PIN <br />
        <small class="orange--text text--lighten-4">
          for {{ election.association.description }} Election
        </small>
      </h2>
      <hr class="my-4" />
      <v-btn to="/" small depressed>
        <v-icon left>mdi-arrow-left-bold</v-icon> Back to Live Elections
      </v-btn>
    </v-card-subtitle>

    <v-card-text class="mt-5">
      <section>
        <v-card flat class="pa-4" v-if="retrieved">
          <h2>Congrats!</h2>
          <p class="mt-4 mb-8 black--text">
            Your E-Voting PIN has been sent to your email:
            <br />
            <u>{{ email }}</u>
          </p>
          <v-btn color="green accent-2" :to="`/vote/${uuid}`">
            Return to login
          </v-btn>
        </v-card>
        <v-form
          v-else
          class="mt-5"
          :disabled="retrieving"
          v-model="retrieveFormValid"
          @submit.prevent="retrievePIN"
        >
          <v-text-field
            v-model="registration"
            prepend-inner-icon="mdi-account"
            :rules="rules.required"
            clearable
            outlined
            placeholder="Reg Number"
            label="Reg Number"
          ></v-text-field>

          <v-text-field
            v-model="dob"
            prepend-inner-icon="mdi-calendar"
            :rules="rules.required"
            clearable
            outlined
            type="date"
            label="Date of Birth"
          ></v-text-field>

          <v-text-field
            v-model="rrr"
            prepend-inner-icon="mdi-credit-card-check"
            :rules="rules.required"
            clearable
            outlined
            v-mask="'NNN-NNN-NNN-NNN'"
            :label="`RRR for Fees of ${election.session.sSesName}`"
          ></v-text-field>

          <v-text-field
            v-model="phone"
            prepend-inner-icon="mdi-phone"
            clearable
            outlined
            :rules="rules.phone"
            v-mask="'NNNN-NNN-NNNN'"
            label="Phone number"
            placeholder="Your phone number"
          ></v-text-field>

          <v-text-field
            v-model="sponsor_phone"
            prepend-inner-icon="mdi-phone"
            clearable
            outlined
            :rules="rules.phone"
            v-mask="'NNNN-NNN-NNNN'"
            label="Sponsor phone number"
            placeholder="Your sponsor phone number"
          ></v-text-field>

          <div class="orange lighten-5 pt-3 px-3 rounded">
            <h3 class="mb-3">
              Provide email where PIN will be sent to <br />
              <small class="red--text">
                Please make sure this is your correct email
              </small>
            </h3>

            <v-text-field
              v-model="email"
              prepend-inner-icon="mdi-email"
              :rules="[...rules.required, ...rules.email]"
              clearable
              outlined
              type="email"
              label="Email"
              placeholder="Email to receive PIN"
              hint="Disposable emails will not work!"
              persistent-hint
            ></v-text-field>
          </div>

          <v-row class="mt-2 pa-3">
            <v-btn
              large
              type="submit"
              class="white--text mb-1 mr-1"
              color="orange darken-3"
              :disabled="retrieving || !retrieveFormValid"
              :loading="retrieving"
            >
              Retrieve PIN
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary darken-1"
              class="mb-1 mt-1 mr-1"
              text
              :to="`/vote/${uuid}`"
            >
              Login Instead
            </v-btn>
          </v-row>
        </v-form>
      </section>
    </v-card-text>
  </v-card>
</template>

<script>
import { phone, email, required } from "../../tools/rules";
import { formatDate } from "../../tools/format";
export default {
  props: ["uuid"],

  data: () => ({
    election: { association: { description: null } },

    rules: {
      email,
      phone,
      required,
    },

    registration: null,
    email: null,
    pin: null,
    rrr: null,
    dob: null,
    mail: null,
    phone: null,
    sponsor_phone: null,

    retrieved: false,
    retrieving: false,
    retrieveFormValid: false,

    phoneFormValid: false,
    electionFound: false,
  }),

  methods: {
    formatDate,
    loadElectionDetails() {
      this.electionFound = false;

      this.$axios
        .get(`/details/${this.uuid}`)
        .then(({ data: election }) => {
          this.election = election;
          this.electionFound = true;
        })
        .catch((error) => {
          if (error.response.status == 404)
            this.$router.push({ name: "elections" });

          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Election not found",
          });
        });
    },

    retrievePIN() {
      this.retrieving = true;

      const data = {
        dob: this.dob,
        registration: this.registration,
        email: this.email,
        phone: this.phone,
        sponsor_phone: this.sponsor_phone,
        rrr: String(this.rrr).toUpperCase(),
      };

      this.$axios({
        url: `/retrieve-pin/beta/${this.uuid}`,
        method: "POST",
        data,
      })
        .then(({ data: { email } }) => {
          this.email = email;

          this.retrieved = true;
        })
        .catch((error) => {
          const { message } = error.response.data;

          this.$bus.$emit("snackbar", {
            type: "error",
            message: message ? message : "Could not retrieve PIN",
          });
        })
        .finally(() => {
          this.retrieving = false;
        });
    },
  },

  mounted() {
    this.loadElectionDetails();
  },
};
</script>

<style>
</style>
